import { Download, FileDown } from "lucide-react"

import { Spinner } from "./spinner"

interface KeepYourReportSectionProps {
  onDownload: () => void
  sizeLabel: string
  /** While the PDF is still loading, the button shows a spinner and is disabled. */
  loading: boolean
}

/** "Keep your report" block: badge icon, copy, and the Download PDF button. */
export function KeepYourReportSection({ onDownload, sizeLabel, loading }: KeepYourReportSectionProps) {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="flex size-24 items-center justify-center rounded-[50px] border border-purple-light/30 bg-gradient-to-bl from-purple-light/20 to-purple-light/5">
        <FileDown className="size-10 text-purple-light" strokeWidth={1.5} />
      </div>

      <div className="flex flex-col gap-1 text-center">
        <p className="font-display text-2xl font-medium text-purple-light">Keep your report</p>
        <p className="font-body text-base text-purple-light/70">
          Download a PDF version and keep your personalized insights wherever you go.
        </p>
      </div>

      <button
        type="button"
        onClick={onDownload}
        disabled={loading}
        className="flex h-14 w-full items-center justify-center gap-2 rounded-[80px] bg-purple-light/10 font-body text-base font-semibold text-purple-light disabled:opacity-70"
      >
        {loading ? <Spinner className="size-6" /> : <Download className="size-6" />}
        Download PDF{sizeLabel && ` (${sizeLabel})`}
      </button>
    </div>
  )
}
